import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { customerActions, customerPaymentActions, httpRequestsOnSuccessActions } from 'store';
import {
  AddButton,
  CsvFile,
  DateFilters,
  DateSelector,
  FullTable,
  PriceConvertor,
  SearchInput,
  useWidth,
} from 'components';
import {
  customerPmtBody,
  customerPmtHead,
  ACTION_TYPE,
  customerPaymentCsv,
} from './constants';
import {
  FindSuccessItem,
  isAdmin,
  PermissionsList,
  RolePermission,
  useModal,
  usePrimaryModal,
  useTertiaryModal,
} from 'utils';
import { AddCustomerPayment, CustomerPaymentInfo } from 'fragments';
import { CustomerPaymentFiltersInfo } from './customerPaymentFiltersInfo';
import moment from 'moment';

const EDIT_ACTION_TYPE = 'EDIT_CUSTOMER_PAYMENT';
const CUSTOMER_PAYMENT_MISCELLANEOUS = 'CUSTOMER_PAYMENT_MISCELLANEOUS';
const CUSTOMER_PAYMENT_VOIDED = 'CUSTOMER_PAYMENT_VOIDED';
const VOID_LOAD_ACTION = 'VOID_CUSTOMER_PAYMENT_LOAD'

export const CustomerPayment = ({}) => {
  const { customerPayments } = useSelector((state) => ({
    customerPayments: state.customerPayments.customerPayments,
  }));
  const dispatch = useDispatch();
  const history = useHistory();
  const info = history?.location?.state;
  const { open } = useModal();
  const { openTertiary } = useTertiaryModal();
  const success = FindSuccessItem(EDIT_ACTION_TYPE);
  const miscellaneousSuccess = FindSuccessItem(CUSTOMER_PAYMENT_MISCELLANEOUS);
  const paymentVoid = FindSuccessItem(CUSTOMER_PAYMENT_VOIDED);
  const voidLoad = FindSuccessItem(VOID_LOAD_ACTION);

  useEffect(() => {
    if(success){
      dispatch(httpRequestsOnSuccessActions.removeSuccess(EDIT_ACTION_TYPE));
      getCustomerPayment('noLoad')
    }
    if(miscellaneousSuccess){
      dispatch(httpRequestsOnSuccessActions.removeSuccess(CUSTOMER_PAYMENT_MISCELLANEOUS));
      getCustomerPayment('noLoad')
    }
    if(paymentVoid){
      dispatch(httpRequestsOnSuccessActions.removeSuccess(CUSTOMER_PAYMENT_VOIDED));
      getCustomerPayment('noLoad')
    }
    if(voidLoad){
      dispatch(httpRequestsOnSuccessActions.removeSuccess(VOID_LOAD_ACTION));
      getCustomerPayment('noLoad')
    }
  }, [success, miscellaneousSuccess, paymentVoid, voidLoad]);

  const renderParams = () => {
    const filteredInfo = {
      ...info,
    };
    filteredInfo.skip = info?.skip ? info?.skip : 0;
    filteredInfo.limit = 100;
    delete filteredInfo.page;
    delete filteredInfo.activeTab;

    if(info?.startDate){
      filteredInfo.startDate = moment.utc(info?.startDate).format('YYYY-MM-DDT00:00:01');
    }else{
      delete filteredInfo.startDate;
    }

    if(info?.endDate){
      filteredInfo.endDate = moment.utc(info?.endDate).format('YYYY-MM-DDT23:59:59');
    }else{
      delete filteredInfo.endDate;
    }

    if (!info?.loadDisplayId) {
      delete filteredInfo.loadDisplayId;
    }
    return filteredInfo;
  };

  // useEffect(() => {
  //   dispatch(customerActions.getCustomers({ status: 'ACTIVE' }));
  // }, []);

  useEffect(() => {
    getCustomerPayment();
  }, [info]);

  const getCustomerPayment = (load) => {
    dispatch(customerPaymentActions.getCustomerPayment(renderParams(), load));
  };

  const pushPageDetails = (item) => {
    if (isAdmin && RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_CUSTOMER_PAYMENT?.code, PermissionsList.CREATE_CUSTOMER_PAYMENT?.code])) {
      openTertiary(<CustomerPaymentInfo id={item?.id} afterSuccess={getCustomerPayment} />);
    }
  };

  return (
    <div>
      <div className="space-between">

        <DateSelector
          startName={'startDate'}
          endName={'endDate'}
        />

        {/*<DateFilters  />*/}
        <div className="flex-align-center" style={{ gap: 16 }}>
          <SearchInput name="loadDisplayId" placeholder="Search for Load ID" />
          {RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.EXPORT_CUSTOMER_PMT_CSV?.code]) &&
            <div className="flex-end" >
              <CsvFile params={customerPaymentCsv} />
            </div>
          }
          {isAdmin && RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.CREATE_CUSTOMER_PAYMENT?.code]) &&
            <AddButton
              handleClick={() => open(<AddCustomerPayment afterSuccess={getCustomerPayment} />)}
              text={'Add'}
            />
          }
        </div>
      </div>

      <CustomerPaymentFiltersInfo />

      <FullTable
        margin={'0'}
        head={customerPmtHead}
        body={customerPmtBody}
        loadingType={ACTION_TYPE}
        list={customerPayments?.pmts}
        listCount={customerPayments?.count}
        handleClick={pushPageDetails}
        clickType={'item'}
        noText={'Carrier Payments'}
      />
    </div>
  );
};